export interface OptionBuyBackExportExcelReq {
  heading: string;
  data: any;
  headers: any;
}

export interface Header {
  key: string;
  value: string;
}

export const buyBackHeadingVal: string = "Employees";
export const buyBackHeadersObj: any = {
  employeeName: "EMPLOYEE NAME",
  granted: "GRANTED OPTIONS",
  vested: "VESTED OPTIONS",
  exercised: "EXERCISED OPTIONS",
  eligibility: "ELIGIBILITY",
  willingness: "WILLINGNESS",
  state: "STATUS",
  totalPriceToPay: "TOTAL STRIKE PRICE",
  totalValueWillingness: "TOTAL CASHOUT AMOUNT",
  totalTaxPercentageSlab: "PERQUISITE TAX(%)",
  surchargePercentage: "SURCHARGE TAX(%)",
  cessChargePercentage: "CESS TAX(%)",
  totalTaxAmount: "TOTAL TAX",
  netPayout: "NET PAYOUT AMOUNT",
  hrId: "HR ID",
  salary: "SALARY",
  isNewRegime: "TAX REGIME",
};
export const buyBackHeaderslist: string[] = [
  "hrId",
  "employeeName",
  "state",
  "granted",
  "vested",
  "exercised",
  "eligibility",
  "willingness",
  "totalTaxPercentageSlab",
  "surchargePercentage",
  "cessChargePercentage",
  "totalValueWillingness",
  "totalPriceToPay",
  "totalTaxAmount",
  "netPayout",
  "salary",
  "isNewRegime",
];

export const perGrantHeadersObj: Record<string, string> = {
  hrId: "HR ID",
  employeeName: "EMPLOYEE NAME",
  grantIdentifier: "GRANT IDENTIFIER",
  planName: "PLAN NAME",
  grantedOptions: "GRANTED OPTIONS",
  vestedOptions: "VESTED OPTIONS",
  eligibility: "ELIGIBILITY",
  willingness: "WILLINGNESS",
  offerState: "STATUS",
  pricePerOption: "PRICE PER OPTION",
  strikePrice: "STRIKE PRICE",
  totalCashout: "TOTAL CASHOUT",
  totalStrikePrice: "TOTAL STRIKE PRICE",
  totalTaxPercentageSlab: "PERQUISITE TAX(%)",
  surchargePercentage: "SURCHARGE TAX(%)",
  cessChargePercentage: "CESS TAX(%)",
  perquisiteTaxAmount: "TOTAL TAX",
  netPayout: "NET PAYOUT",
  salary: "SALARY",
  isNewRegime: "TAX REGIME",
};
export const perGrantHeadersList: string[] = Object.keys(perGrantHeadersObj);
